<template>
	<div class="content-card wallet-card">
		<div class="wallet-tabs">
			<div class="tab-item" :class="{ active: activeTab === 'wallet' }" @click="activeTab = 'wallet'">我的钱包</div>
			<div class="tab-item" :class="{ active: activeTab === 'details' }" @click="activeTab = 'details'">余额明细</div>
		</div>

		<!-- Recharge View -->
		<div v-if="activeTab === 'wallet'">
			<!-- Balance Card -->
			<div class="balance-banner">
				<div class="balance-info">
					<p class="balance-label">钱包余额</p>
					<p class="balance-amount">{{ walletBalance }}</p>
				</div>

			</div>

			<!-- Recharge Options -->
			<div class="recharge-section">
				<h3 class="section-title">选择充值金额</h3>
				<div class="options-grid">
					<div class="option-card" v-for="(option,index) in rechargeOptions"
						:key="option.rechargePackageId || index"
						:class="{ active: selectedRechargeId === option.rechargePackageId && !customAmount }"
						@click="selectPackage(option.rechargePackageId)">
						<div class="amount">¥{{ option.price }}</div>
						<div class="bonus">送{{ option.giftAmount }}</div>
						<div class="check-mark" v-if="selectedRechargeId === option.rechargePackageId && !customAmount">
							✓</div>
					</div>
				</div>

				<!-- Custom Amount -->
				<div class="custom-amount">
					<div class="input-wrapper">
						<span class="edit-icon">✎</span>
						<input type="number" placeholder="自定义金额" v-model="customAmount" @input="handleCustomAmount" />
					</div>
				</div>

				<!-- Recharge Button -->
				<div class="recharge-action">
					<button class="recharge-btn" @click="handleRecharge">立即充值</button>
				</div>
			</div>
		</div>

		<!-- Payment QR Code Modal -->
		<div class="modal-overlay" v-if="showPayModal" @click.self="showPayModal = false">
			<div class="modal-content pay-modal">
				<div class="modal-header">
					<h3>微信支付</h3>
					<span class="close-btn" @click="showPayModal = false">&times;</span>
				</div>
				<div class="modal-body">
					<transition name="qr-fade" mode="out-in">
						<div class="qr-container" v-if="payQrCode" key="qr">
							<img :src="payQrCode" alt="Payment QR Code" />
							<p>请使用微信扫一扫支付</p>
						</div>
						<div class="loading" v-else key="loading">
							<span class="spinner"></span>
							<p>正在生成支付二维码...</p>
						</div>
					</transition>
				</div>
			</div>
		</div>

		<!-- Balance Details View -->
		<div v-if="activeTab === 'details'" class="details-section">
			<ul class="details-list">
				<li v-for="item in balanceDetails" :key="item.id" class="detail-item">
					<div class="item-left">
						<div class="item-type">{{ item.title }}</div>
						<div class="item-date">{{ item.createTime }}</div>
					</div>
					<div class="item-right">
						<span class="item-amount">{{ item.amount }}</span>
					</div>
				</li>
			</ul>
			<div class="no-more">暂无更多~</div>
		</div>
	</div>
</template>

<script>
	import {
		getRechargePackages
	} from '@/api/public'
	import {
		getBalanceRecords,
		createRechargeOrder,
		miniAppPay
	} from '@/api/order'
	import {
		getUserProfile
	} from '@/api/user'
	import {
		ElMessage
	} from 'element-plus'
	import 'element-plus/es/components/message/style/css'

	export default {
		name: 'MyWallet',
		data() {
			return {
				activeTab: 'wallet', // Default to wallet for recharge
				walletBalance: 0,
				balanceDetails: [],
				rechargeOptions: [],
				selectedRechargeId: null,
				customAmount: '',
				showPayModal: false,
				payQrCode: ''
			}
		},
		created() {
			this.initData()
		},
		methods: {
			async initData() {
				this.fetchUserProfile()
				this.fetchRechargePackages()
				this.fetchBalanceRecords()
			},
			selectPackage(id) {
				this.selectedRechargeId = id
				this.customAmount = '' // Clear custom amount when package is selected
			},
			handleCustomAmount() {
				if (this.customAmount) {
					this.selectedRechargeId = null // Clear selection when typing custom amount
				}
			},
			async handleRecharge() {
				// Validate
				if (!this.selectedRechargeId && !this.customAmount) {
					// You might want to use a toast here
					ElMessage.warning('请选择或输入充值金额')
					return
				}

				const data = {}
				if (this.customAmount) {
					data.amount = Number(this.customAmount)
				} else {
					data.rechargePackageId = this.selectedRechargeId
				}

				try {
					// 1. Create Order
					const orderRes = await createRechargeOrder(data)
					if (orderRes) { // Assuming response is the order object or contains id
						console.log(orderRes)
						const ordersId = orderRes.orderId // Adjust based on actual API response

						// 2. Call Pay
						this.showPayModal = true
						this.payQrCode = '' // Reset

						const payRes = await miniAppPay({
							ordersId: ordersId,
							payType: 3 // 1: WeChat, 2: Wallet. Recharge must be WeChat.
						})

						// 3. Handle Pay Response (QR Code)
						// Assuming payRes contains the QR code string/url
						// 适配后端返回结构，根据截图，res.data 包含 codeUrl
						// 如果拦截器返回了 res.data，则 payRes 即为该对象
						if (payRes && (payRes.codeUrl || payRes.code_url)) {
							const codeUrl = payRes.codeUrl || payRes.code_url
							// 使用在线 API 生成二维码图片
							this.payQrCode = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(codeUrl)}`
						} else if (typeof payRes === 'string' && payRes.startsWith('weixin://')) {
							this.payQrCode = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(payRes)}`
						} else {
							// 兜底：如果 payRes 是 base64 或图片链接
							this.payQrCode = payRes.codeUrl || payRes.qrCode || payRes
						}
					}
				} catch (error) {
					console.error('充值失败:', error)
					ElMessage.error('充值发起失败，请重试')
					this.showPayModal = false
				}
			},
			async fetchUserProfile() {
				try {
					const res = await getUserProfile()
					this.walletBalance = res.balance || 0
				} catch (error) {
					console.error('获取用户信息失败', error)
				}
			},
			async fetchRechargePackages() {
				try {
					const res = await getRechargePackages()
					// 假设返回的数据结构直接是数组，或者在data字段中
					this.rechargeOptions = Array.isArray(res) ? res : (res.data || [])
					if (this.rechargeOptions.length > 0) {
						this.selectedRechargeId = this.rechargeOptions[0].rechargePackageId

					}
				} catch (error) {
					console.error('获取充值套餐失败', error)
				}
			},
			async fetchBalanceRecords() {
				try {
					const res = await getBalanceRecords()
					this.balanceDetails = res.rows || res.data || []
				} catch (error) {
					console.error('获取余额明细失败', error)
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.content-card {
		background-color: #1e1e1e;
		border-radius: 4px;
		min-height: 600px;
		padding: 20px 10px;
		border-bottom: 1px solid #333;

		&.wallet-card {
			background-color: #1e1e1e;
			padding: 0; // Reset padding for custom layout
		}

		/* Wallet Specific Styles */
		.wallet-tabs {
			display: flex;
			border-bottom: 1px solid #333;
			padding: 0 40px;
			margin-bottom: 30px;

			.tab-item {
				padding: 20px 0;
				margin-right: 40px;
				color: #999;
				cursor: pointer;
				font-size: 16px;
				position: relative;

				&.active {
					color: #fff;
					font-weight: bold;

					&::after {
						content: '';
						position: absolute;
						bottom: 0;
						left: 0;
						width: 100%;
						height: 3px;
						background-color: #ff9900;
					}
				}
			}
		}

		.balance-banner {
			margin: 0 40px 30px;
			height: 120px;
			background-image: url('@/assets/image/walletBalanceBackground.png');
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center;
			border-radius: 8px;
			padding: 0 40px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			position: relative;
			overflow: hidden;
			border: 1px solid #333;

			.balance-info {
				z-index: 1;

				.balance-label {
					color: #999;
					font-size: 14px;
					margin-bottom: 10px;
				}

				.balance-amount {
					color: #ffd700;
					font-size: 36px;
					font-weight: bold;
				}
			}

			.coin-decoration {
				width: 100px;
				height: 100px;
				background-color: #ffd700;
				border-radius: 50%;
				position: absolute;
				right: -20px;
				top: 50%;
				transform: translateY(-50%);
				opacity: 0.2;
				box-shadow: 0 0 20px #ffd700;

				&::before {
					content: '¥';
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					font-size: 60px;
					color: #000;
					opacity: 0.5;
				}
			}
		}

		.recharge-section {
			padding: 0 40px;

			.section-title {
				font-size: 16px;
				color: #ddd;
				margin-bottom: 20px;
				font-weight: normal;
			}

			.options-grid {
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				gap: 20px;
				margin-bottom: 30px;

				.option-card {
					background-color: #2c2c2c;
					border: 1px solid #333;
					border-radius: 4px;
					padding: 20px;
					text-align: center;
					cursor: pointer;
					position: relative;
					transition: all 0.3s ease;

					&:hover {
						border-color: #ff9900;
					}

					&.active {
						border-color: #ff9900;
						border-image: linear-gradient(360deg, rgba(245, 183, 107, 1), rgba(254, 142, 4, 1)) 1 1;

						.amount {
							color: #ff9900;
						}
					}

					.amount {
						font-size: 24px;
						color: #fff;
						margin-bottom: 5px;
					}

					.bonus {
						font-size: 14px;
						color: #999;
					}

					.check-mark {
						position: absolute;
						bottom: 0;
						right: 0;
						background-color: #ff9900;
						color: #000;
						width: 20px;
						height: 20px;
						font-size: 12px;
						display: flex;
						align-items: center;
						justify-content: center;
						border-top-left-radius: 4px;
					}
				}
			}

			.custom-amount {
				margin-bottom: 40px;

				.input-wrapper {
					position: relative;
					width: 424px;

					.edit-icon {
						position: absolute;
						left: 15px;
						top: 50%;
						transform: translateY(-50%);
						color: #999;
					}

					input {
						width: 100%;
						height: 50px;
						background-color: #2c2c2c;
						border: 1px solid #333;
						border-radius: 4px;
						padding: 0 15px 0 40px;
						color: #fff;
						font-size: 16px;
						box-sizing: border-box;

						&:focus {
							outline: none;
							border-color: #ff9900;
						}
					}
				}
			}

			.recharge-action {
				margin: 0 auto;
				text-align: center;

				.recharge-btn {
					margin: 0 auto;
					text-align: center;
					width: 434px;
					height: 45px;
					background: #FE8E04;
					border-radius: 4px 4px 4px 4px;
					border: none;
					color: #fff;
					font-size: 16px;
					cursor: pointer;
					transition: opacity 0.3s;

					&:hover {
						opacity: 0.9;
					}
				}
			}
		}

		/* Details List Styles */
		.details-section {
			padding: 0 40px;

			.details-list {
				list-style: none;
				padding: 0;
				margin: 0;

				.detail-item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 15px 0;
					border-bottom: 1px dashed #333;

					.item-left {
						.item-type {
							font-size: 16px;
							color: #ddd;
							margin-bottom: 5px;
						}

						.item-date {
							font-size: 14px;
							color: #666;
						}
					}

					.item-right {
						.item-amount {
							font-size: 18px;
							color: #fff;
							font-family: monospace;
						}
					}
				}
			}

			.no-more {
				text-align: center;
				color: #666;
				font-size: 14px;
				margin-top: 30px;
				padding-bottom: 20px;
			}
		}
	}

	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}

	.modal-content {
		background-color: #fff;
		width: 400px;
		border-radius: 8px;
		padding: 20px;
		color: #333;
		position: relative;
	}

	.modal-header {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 20px;
		position: relative;

		h3 {
			margin: 0;
			font-size: 18px;
		}

		.close-btn {
			position: absolute;
			right: 0;
			top: -10px;
			font-size: 24px;
			cursor: pointer;
			color: #999;

			&:hover {
				color: #333;
			}
		}
	}

	.qr-container {
		display: flex;
		flex-direction: column;
		align-items: center;

		img {
			width: 200px;
			height: 200px;
			margin-bottom: 15px;
		}

		p {
			color: #666;
			font-size: 14px;
		}
	}

	.loading {
		text-align: center;
		padding: 40px 0;
		color: #666;

		.spinner {
			display: inline-block;
			width: 24px;
			height: 24px;
			border: 3px solid rgba(0, 0, 0, 0.1);
			border-top-color: #409eff;
			border-radius: 50%;
			animation: spinner-rotate 0.8s linear infinite;
			margin-bottom: 10px;
		}

		p {
			margin: 0;
		}
	}

	/* 二维码生成 / 显示动画 */
	.qr-fade-enter-active,
	.qr-fade-leave-active {
		transition: opacity 0.3s ease, transform 0.3s ease;
	}

	.qr-fade-enter-from,
	.qr-fade-leave-to {
		opacity: 0;
		transform: scale(0.9);
	}

	.qr-fade-enter-to,
	.qr-fade-leave-from {
		opacity: 1;
		transform: scale(1);
	}

	@keyframes spinner-rotate {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}
</style>